/**
 * Created by PhpStorm.
 * User: i.sollima
 * Contact: i.sollima@accenture.com
 * Date: 16/07/2019
 * Time: 12:09
 */

//callApi({uri: "<uri>", method: "<method, default GET>"}).then((response)=>{console.log(response)}).catch((e)=>{console.error(e.message)});

function callApi(config) {
  const _config = {
    uri: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: false,
    timeout: 60000,
    method: 'GET',
  };

  if (typeof config === 'string') {
    config = { uri: config };
  }
  config = extend(_config, config);

  function init(config) {
    return new Promise((resolve, _) => {
      if (getTokenCookie('csrfToken')) {
        resolve(getTokenCookie('csrfToken'));
      } else {
        resolve(drupalSettings.authTokenBE);
        /*fetch('/session/token').then((token) => {
          createCookieWithValue('csrfToken', '', -3600);
          resolve(token.text());
        });*/
      }
    }).then((token) => {
      createCookieWithValue('csrfToken', token, 60);
      let { uri, method, headers, data } = config;
      if (uri) {
        let body;
        if (method === 'POST' && data) {
          body = JSON.stringify(data);
        }
        return timeout(
          config.timeout,
          fetch(uri, {
            headers: {
              ...headers,
              'X-CSRF-Token': token,
            },
            method: method,
            body,
          }),
        );
      }
    });
  }

  return init(config);

  // Rough implementation. Untested.
  function timeout(ms, promise) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject(new Error('Timeout'));
      }, ms);
      promise.then(resolve, reject);
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(
            `${response.status} - ${
              response.statusText || 'No message from server.'
            }`,
          );
        }
      })
      .catch((e) => {
        if (e.message && e.message.indexOf('403') > -1) {
          createCookieWithValue('csrfToken', '', -3600);
          return init(config);
        }
        console.error(e);
        return new Promise(() => {});
      });
  }
}
initializeUtilsFunctions();
publish(callApi, 'callApi');
